const FileUploadSVG = () => {
    return (

        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3914_13511)">
                <path d="M7.49996 17.9992C6.25223 17.9992 5.05561 17.5251 4.17334 16.6812C3.29107 15.8373 2.79541 14.6927 2.79541 13.4992C2.79541 12.3057 3.29107 11.1612 4.17334 10.3172C5.05561 9.47333 6.25223 8.99922 7.49996 8.99922C7.79464 7.6864 8.65672 6.5327 9.89654 5.79193C10.5104 5.42514 11.1986 5.17077 11.9217 5.04333C12.6449 4.9159 13.3888 4.9179 14.1111 5.04922C14.8333 5.18054 15.5198 5.43861 16.1312 5.8087C16.7427 6.17878 17.2672 6.65364 17.6747 7.20615C18.0823 7.75866 18.3649 8.378 18.5065 9.02882C18.6481 9.67963 18.6459 10.3492 18.5 10.9992H19.5C20.4282 10.9992 21.3185 11.368 21.9748 12.0243C22.6312 12.6807 23 13.571 23 14.4992C23 15.4275 22.6312 16.3177 21.9748 16.9741C21.3185 17.6305 20.4282 17.9992 19.5 17.9992H18.5" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.5 15L12.5 12L15.5 15" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.5 12V21" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3914_13511">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default FileUploadSVG;
